import moment from "moment-timezone";

export default class Utils {
  static STAGING_MODE = window.document.domain.indexOf('stage') !== -1;
  static DEV_MODE = process.env.NODE_ENV === 'development';

  static STW_CLASSIC = 'STW_CLASSIC';
  static STW_DELUXE = 'STW_DELUXE';

  static getUniqNumber() {
    return (Date.now() * Math.floor(Math.random() * 100)) * Math.random();
  }

  /**
   * @returns object first key
   */
  static firstKey(object) {
    return object ? Object.keys(object)[0] : '';
  }

  /**
   * @returns object first key
   */
  static lastKey(object) {
    return object ? Object.keys(object)[Object.keys(object).length - 1] : '';
  }

  /**
   *
   * @param timestamp
   * @param bySeconds format of result
   * @param hardFormat ignore bySeconds param and hard set param value.
   */
  static toLocalTime(timestamp, bySeconds, hardFormat) {
    const offset = new Date(timestamp).getTimezoneOffset();
    const utcString = new Date(timestamp * 1000 - offset).toUTCString();
    const format = hardFormat ? hardFormat : (bySeconds ? 'HH:mm:ss' : 'HH:mm');

    return moment.utc(utcString).local().format(format);
  }

  static getTimesDifference = (startTime, endTime) => {
    const formattedEndTime = moment(startTime, "HH:mm:ss");
    const formattedCurrentTime = moment(endTime, "HH:mm:ss");
    const timeLeft = formattedEndTime.diff(formattedCurrentTime);
    return moment.utc(timeLeft).format("mm:ss");
  }

  static getURLParams = e => {
    const iFrameURL = new URL(document.location.href);

    // TODO: In Firefox old versions, the native "fromEntries" method can't worked correctly.
    return Object.fromEntries([...iFrameURL.searchParams.entries()]);
  }
}